export default __webpack_public_path__ + "static/media/foodmarble-healthcare.6dcf47b7.png";